'use client'

import Image from 'next/image'
import { Media } from '@/payload-types'
import { getScreenStyle } from '@/blocks/BlockStyle'
import { cn } from '@/utilities/cn'
import getTailwindScreens from '@/lib/common/utils/getTailwindScreens'
import { useTailwindScreen } from '@/lib/client/hooks/useTailwindScreen'

export default function ProfilePicture({
  media,
  size: sizeProp,
  className,
}: {
  media: Media | string
  size?: 'normal' | 'small'
  className?: string
}) {
  const url = typeof media === 'string' ? media : media.url
  const alt = typeof media === 'string' ? 'Profielfoto' : (media.alt ?? 'Profielfoto')
  sizeProp ??= 'normal'
  const screens = getTailwindScreens()
  const screen = useTailwindScreen()
  const scale = sizeProp === 'small' ? 0.75 : 1
  const responsiveSize = {
    base: 100 * scale,
    lg: 150 * scale,
  }
  const { size } = getScreenStyle(
    {
      size: responsiveSize,
    },
    screen,
  )
  const sizes = ['100px', `(max-width: ${screens.lg}) 150px`].join(', ')
  return (
    <div
      className={cn(`relative rounded-full overflow-hidden border-4 border-primary`, className)}
      style={{
        width: size + 'px',
        height: size + 'px',
        minWidth: size + 'px',
        minHeight: size + 'px',
        maxWidth: size + 'px',
        maxHeight: size + 'px',
      }}
    >
      {url && (
        <Image
          alt={alt}
          className={`object-cover object-center`}
          sizes={sizes}
          fill={true}
          src={url}
        />
      )}
    </div>
  )
}
